const StationClass = {
  SCI: "SCI",
  GUI: "GUI",
  EFTI: "EFTI",
  NA: "N/A",
};

export default StationClass;
